import { styled } from '@mui/material/styles'

export const DisabledWrapper = styled('div')<{ disabled: boolean; opacity?: number }>`
  ${props =>
    props.disabled
      ? `
          cursor: default;
          pointer-events: none;
          opacity: ${props.opacity ?? 0.2};
        `
      : ''}
`
